<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee">
            <div class="welcome-container">
                <div class="title">{{ errormessage.title }}</div>
                <div class="detail">{{ errormessage.detail }}</div>
            </div>
        </div>
    </div>
</template>

<script>
// import Vue from 'vue'
// helper //
import Locale from "@/helper/locale/locale.js";

// core //

// mixins
import Mixin from "@/mixin/Mixin";
import ModalMixin from "@/mixin/ModalMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";

export default {
    name: "Welcome",
    components: {},
    mixins: [Mixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            lbl: Locale.getLbl(),
            locale: Locale.getLocaleCode(),
            errormessage: {}
        };
    },
    created() {
        this.handleLoading(true);
        this.errormessage.title = "เกิดข้อผิดพลาด";
        this.errormessage.detail = this.$route.params.data
            ? this.$route.params.data
            : "SometingError";
        this.handleLoading(false);
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
$primary-color: #4d341c;
$secondary-color: rgb(167, 144, 123);
.wrapper-bg {
    padding-bottom: 0;
}
.coffee {
    position: relative;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    &:after {
        display: none;
    }
}
.welcome-container {
    color: #fff;
    text-align: center;
    position: relative;
    .bg-coffee {
        width: 100%;
        height: 0;
        padding-bottom: 94.4%;
        position: absolute;
        bottom: 0;
        left: 50%;
        z-index: 1;
        background: url("../../../assets/survey/bg.png") center no-repeat;
        background-size: cover;
        transform: translate(-50%, 0);
    }
    .title {
        font-family: "PromptSemiBold";
        font-size: 20px;
        &:before {
            content: "";
            width: 20px;
            height: 11px;
            background: url("../../../assets/icon/text-start.svg") center
                no-repeat;
            display: inline-block;
            margin-right: 5px;
            vertical-align: super;
        }
        &:after {
            content: "";
            width: 20px;
            height: 11px;
            background: url("../../../assets/icon/text-end.svg") center
                no-repeat;
            display: inline-block;
            margin-left: 5px;
            vertical-align: bottom;
        }
    }
    .detail {
        font-size: 16px;
        padding: 30px 20px 60px;
        white-space: pre-wrap;
    }
}
</style>
